module.exports = __webpack_public_path__ + "img/taiyos2.07f3597d.gif";